import type { CaseItem } from "@/mocks/lawfirm";

export default function CaseCard({
  item,
  onClick,
  hideThumbnailOnMobile = false,
  clampDescOnMobile = false,
}: {
  item: CaseItem;
  onClick: (item: CaseItem) => void;
  hideThumbnailOnMobile?: boolean;
  clampDescOnMobile?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={() => onClick(item)}
      className="group block w-full cursor-pointer overflow-hidden rounded-lg bg-white border border-background-200 text-left transition-colors hover:border-accent-400/60"
    >
      <div
        className={`relative h-44 w-full overflow-hidden ${
          hideThumbnailOnMobile ? "hidden md:block" : ""
        }`}
      >
        <img
          src={item.thumbnail}
          alt={item.title}
          title={`${item.title} 성공사례`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded bg-primary-950/80 px-3 py-1 text-xs font-semibold text-white">
          {item.category}
        </span>
      </div>
      <div className="p-5">
        {hideThumbnailOnMobile && (
          <span className="mb-2 inline-block rounded bg-primary-950/80 px-3 py-1 text-xs font-semibold text-white md:hidden">
            {item.category}
          </span>
        )}
        <h3 className="font-heading text-base font-semibold text-foreground-900">{item.title}</h3>
        <p
          className={`mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed ${
            clampDescOnMobile ? "line-clamp-1 md:line-clamp-none" : ""
          }`}
        >
          {item.desc}
        </p>
      </div>
    </button>
  );
}